module.exports = __webpack_public_path__ + "img/trash.93783d09.svg";